/* eslint-disable no-param-reassign */
import { mobxSet } from '@src/slide/infrastructure/module/independent/assert/get-set';
import BaseModel from './base-modeles/base-model';
import AnimHandler, { AnimListItem } from './../adapter/anim-handler';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { ITimingModel } from '@src/slide/domain/ui-model/element-modeles/Interface/timing-model.interface';
import { nodeTypes } from '@src/slide/domain/ui-model/element-modeles/property/animation/constant';
import {
    TimingPropertyConverter,
} from '@src/slide/domain/ui-model/converter/node-property/page/timing-property-converter';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';

class TimingModel extends BaseModel implements ITimingModel {
    static async convertDataSdkToUi(sdkData, uiData, rawSdkData) {
        super.convertDataSdkToUi(sdkData, uiData, rawSdkData);
        TimingPropertyConverter.convertPartialDataFromSdkToUi(sdkData.props, uiData);
    }

    static getAnimTargetIdSet(timingSdkData) {
        if (!timingSdkData) return new Set();
        const animTargetIdSet = new Set();
        timingSdkData?.tmRoot?.childTnLst?.forEach((mainOrIaSeq) => {
            mainOrIaSeq?.cTn?.childTnLst?.forEach((clickTns) => {
                clickTns?.cTn?.childTnLst?.forEach((clickOrAfterTns) => {
                    clickOrAfterTns?.cTn?.childTnLst?.forEach((afterOrWithTns) => {
                        afterOrWithTns?.cTn?.childTnLst?.forEach((tn) => {
                            const spid = tn?.cBhvr?.tgtEl?.spTgt?.spid;
                            if (typeof spid === 'undefined') return animTargetIdSet;
                            animTargetIdSet.add(spid);
                        });
                    });
                });
            });
        });
        return animTargetIdSet;
    }

    declare public parent: ISlideModel | null;
    // @ts-ignore
    declare public children: AnimListItem[];
    public animTargetIdSet: Set<string>;
    constructor() {
        super();
        this.type = UIModelType.TIMING;
        const animHandler = new AnimHandler(this);
        Object.defineProperty(this, 'animHandler', {
            value: animHandler,
            writable: true,
        });
        this.animTargetIdSet = new Set(); // 该页所有动画目标元素的id
    }


    resetAnimOrder() {
        this.parent?.animList.forEach((animListItem) => {
            let order = 0;
            animListItem.data.forEach((animModel) => {
                if (animModel.props.nodeType === nodeTypes.CLICK_EFFECT) {
                    order += 1;
                }
                mobxSet(animModel, 'order', order);
            });
        });
    }

    removeAllObserverTarget() {
        this.unsubscribeMap.forEach(e => e());
        this.unsubscribeMap.clear();
    }
}

export default TimingModel;
